/*
 * Author M. Atoar Rahman
 * Title: Stock Reigister
 * Description: Stock Reigister
 * Date: 15/07/2022
 */

import moment from 'moment';
import React from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import { useStockRegister } from './ContextAPI';

function ComponentToPrint(props, ref) {
    const { pdfData } = useStockRegister();

    return (
        <fieldset ref={ref} className="customFieldset p-5">
            <Row className="mb-5">
                <Col className="text-center">
                    <h3 style={{ textTransform: 'uppercase' }}>{pdfData?.stock_from}</h3>
                    <h5>Stock Card</h5>
                </Col>
            </Row>
            <Row className="mb-3">
                <Table borderless>
                    <tbody style={{ display: 'grid' }}>
                        <tr>
                            <td width="105px">
                                <b>Item Name:</b>
                            </td>
                            <td>{pdfData?.drug_name}</td>
                        </tr>
                        <tr>
                            <td width="105px">
                                <b>Date From: </b>
                            </td>
                            <td width="115px">
                                {moment(pdfData?.date_from).format('DD MMM YYYY')}
                            </td>
                            <td width="105px">
                                <b>Date To:</b>
                            </td>
                            <td>{moment(pdfData?.date_to).format('DD MMM YYYY')}</td>
                        </tr>
                    </tbody>
                </Table>
            </Row>
            <Row>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th width="100px">Date</th>
                            <th>Particulars</th>
                            <th>Opening Balance</th>
                            <th>Received Qty</th>
                            <th>Total Qty</th>
                            <th>Issue Qty</th>
                            <th>Bill No</th>
                            <th>Balance</th>
                            <th>Remarks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pdfData?.stock_list?.map((el) => (
                            <tr key={Math.random()}>
                                <td>{moment(el.date).format('DD MMM YYYY')}</td>
                                <td>{el.particular}</td>
                                <td>{el.opening_stock}</td>
                                <td>{el.receive_qty}</td>
                                <td>{el.total_qty}</td>
                                <td>{el.issue_qty}</td>
                                <td>{el.grn_waybill_no}</td>
                                <td>{el.closing_stock}</td>
                                <td />
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Row>
        </fieldset>
    );
}

const forwardedInput = React.forwardRef(ComponentToPrint);

export default forwardedInput;
